import { message } from 'antd'
import CantileverCard from 'components/CantileverCard'
import { AssetOverviewDataContext } from 'features/assetDatabase/contexts/AssetOverviewDataLayer'
import { AssetOverviewUXContext } from 'features/assetDatabase/contexts/AssetOverviewUXLayer'
import { AssetDataObjComponentType } from 'features/assetDatabase/types/assetOverviewTypes'
import { getFeatureTableOptionsByType } from 'features/assetDatabase/utils/assetDBFeatures'
import { useGeckoAuth } from 'features/auth'
import { useGeckoLocale } from 'features/locale'
import React, { useContext, useRef } from 'react'
import { componentAvailableFeatures } from 'types'

import { AssetModelComponentForm } from './AssetModelComponentForm'
import { ComponentCard } from './ComponentCard'
import { FeatureSectionContent } from './FeatureSectionContent'

export const AssetModelComponentCard: React.FC<{
  component: AssetDataObjComponentType
  forceRefresh: () => Promise<void>
}> = ({ component, forceRefresh }) => {
  const formRef = useRef<HTMLFormElement>(null)

  const {
    inResolveMode,
    inEditMode,
    handleSaveToRolodex,
    handleComponentDelete,
  } = useContext(AssetOverviewUXContext)
  const { assetDataObj, refreshData } = useContext(AssetOverviewDataContext)
  const { permissions } = useGeckoAuth()
  const [messageApi] = message.useMessage()
  const { measurementSystem } = useGeckoLocale()

  const currentComponentID = component.componentData.uniqueID
  const componentName = component.componentData.componentJSON.name
  const componentType = component.componentData.componentJSON.type
  const currentlyEditingComponent = inEditMode.includes(currentComponentID)

  const componentFeatureTypes = componentAvailableFeatures(componentType)
  const handleDelete = () => {
    handleComponentDelete(currentComponentID, messageApi, forceRefresh)
  }
  return (
    <ComponentCard
      componentID={currentComponentID}
      componentName={componentName}
      handleDelete={handleDelete}
      deleteMessage={
        'Are you sure you want to delete this component metadata from the asset model?'
      }
      ref={formRef}
      infoTable={
        assetDataObj &&
        permissions &&
        assetDataObj.assetModel && (
          <AssetModelComponentForm
            assetDataObj={assetDataObj}
            assetModel={assetDataObj.assetModel}
            componentID={currentComponentID}
            measurementSystem={measurementSystem}
            inEditMode={currentlyEditingComponent}
            inResolveMode={inResolveMode}
            forceRefresh={refreshData}
            ref={formRef}
            userPermissions={permissions}
            handleSaveToRolodex={handleSaveToRolodex}
          />
        )
      }
      featureTable={componentFeatureTypes.map((featureType) => {
        const featureTableOptions = getFeatureTableOptionsByType(featureType)
        return (
          <div key={featureType}>
            {featureTableOptions && (
              <CantileverCard.Section key={featureType} topBorder>
                <FeatureSectionContent
                  componentID={currentComponentID}
                  tableTitle={featureTableOptions.title}
                  addName={featureTableOptions.singularName}
                  sortBy={featureTableOptions.sortBy}
                  tableMessage={featureTableOptions.tableMessage}
                  disableEditing={featureTableOptions.disableEditing ?? false}
                  featureType={featureType}
                  forceRefresh={forceRefresh}
                />
              </CantileverCard.Section>
            )}
          </div>
        )
      })}
    />
  )
}
